export const subFlowDocumentationMarkdown = `
# Subflow

Pick a child flow to run as a subflow.

### Input
 - **Version Target**: Choose the version targeting strategy:
   - **Published**: Run the Published version of the specified flow
   - **Specific Version**: Select a specific version to pin to, which will always be used irrespective of the state of the specified version
     *Note*: You can NOT publish a flow if it includes subflows which are pinned to Unpublished subflow versions!
 - **Flow**: When using Version Target *Published*, Choose a flow to run as a subflow (the selected flow **must** have a Published version!)
 - **Flow Version**: When using Version Target *Specific Version*, choose the specific version of the flow to run
 - **Start Data**: (Optional): Upstream block data to pass into the child flow

### Output
In your child flow, use an Output block to return data to the parent flow (ie, this flow). You can only have one Output block in your child flow, and you will need to specify the block whose data you want to return. If you need to return multiple values, you can use a script block to return a JSON object with multiple values. See the Output block documentation for more information.
`;
